import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	projectFieldLabel: {
		id: 'issue-create.modal.create-form.project-field-label',
		defaultMessage: 'Projects',
		description: 'Label for project field in issue create form',
	},
	createSuccessFlagTitle: {
		id: 'issue-create.modal.create-form.create-success-flag-title',
		defaultMessage: 'Issue created',
		description: 'Title for success flag when issue is created',
	},
	createSuccessFlagDescription: {
		id: 'issue-create.modal.create-form.create-success-flag-description',
		defaultMessage: 'Issue "{issueKey}" has been successfully created.',
		description: 'Description for success flag when issue is created',
	},
	createSuccessFlagCta: {
		id: 'issue-create.modal.create-form.create-success-flag-cta',
		defaultMessage: 'View issue',
		description: 'CTA for success flag when issue is created',
	},
	createErrorFlagTitle: {
		id: 'issue-create.modal.create-form.create-error-flag-title',
		defaultMessage: "Couldn't create the issue",
		description: 'Title for error flag when issue create fails',
	},
	createErrorFlagDescription: {
		id: 'issue-create.modal.create-form.create-error-flag-description',
		defaultMessage: "We're having some trouble creating the issue. Refresh the page and try again.",
		description: 'Description for error flag when issue create fails',
	},
	embeddedCreateErrorFlagDescription: {
		id: 'issue-create.modal.create-form.embedded-create-error-flag-description',
		defaultMessage: "We weren't able to save your issue. Please try again.",
		description: 'Description for error flag when embedded issue creation fails',
	},
	embeddedCreateErrorFlagDescriptionIssueTermRefresh: {
		id: 'issue-create.modal.create-form.embedded-create-error-flag-description-issue-term-refresh',
		defaultMessage: "We weren't able to save your work item. Please try again.",
		description: 'Description for error flag when embedded issue creation fails',
	},
	createErrorForgeInlineField: {
		id: 'issue-create.modal.create-form.create-error-forge-inline-field',
		defaultMessage: 'Unable to save the value for this custom field.',
		description: 'Error message shown when getting field value failed.',
	},
	timeoutForgeInlineFieldTitle: {
		id: 'issue-create.modal.create-form.timeout-forge-inline-field-title',
		defaultMessage: 'Issue created with exceptions',
		description: 'Title for warning flag shown when issue was created with exceptions.',
	},
	timeoutForgeInlineFieldDescription: {
		id: 'issue-create.modal.create-form.timeout-forge-inline-field-description',
		defaultMessage:
			"We created your issue but couldn't save the value of <bold>{fields}</bold>. If this happens again, contact your Jira admin",
		description:
			'Description for warning flag shown when issue was created but some of the fields do not have anticipated value.',
	},
	requiredFieldsSummary: {
		id: 'issue-create.modal.create-form.required-fields-summary',
		defaultMessage: 'Required fields are marked with an asterisk',
		description: 'Summary info of required fields asterisk.',
	},
	singleRequiredCustomFieldIssueCreationBlock: {
		id: 'issue-create.modal.create-form.single-required-custom-field-issue-creation-block',
		defaultMessage:
			'You can’t create this issue because the required field {fieldName} is hidden. Contact your admin to fix this.',
		description:
			'Description for warning flag shown when issue creation is blocked by single required custom field hidden by display conditions',
	},
	multipleRequiredCustomFieldsIssueCreationBlock: {
		id: 'issue-create.modal.create-form.multiple-required-custom-fields-issue-creation-block',
		defaultMessage:
			'You can’t create this issue because the required fields are hidden: {fieldsName}. Contact your admin to fix this.',
		description:
			'Description for warning flag shown when issue creation is blocked by multiple required custom fields hidden by display conditions',
	},
	createSuccessFlagTitleIssueTermRefresh: {
		id: 'issue-create.modal.create-form.create-success-flag-title-issue-term-refresh',
		defaultMessage: 'Work item created',
		description: 'Title for success flag when issue is created',
	},
	createSuccessFlagCtaIssueTermRefresh: {
		id: 'issue-create.modal.create-form.create-success-flag-cta-issue-term-refresh',
		defaultMessage: 'View',
		description: 'CTA for success flag when issue is created',
	},
	createErrorFlagTitleIssueTermRefresh: {
		id: 'issue-create.modal.create-form.create-error-flag-title-issue-term-refresh',
		defaultMessage: "Couldn't create the work item",
		description: 'Title for error flag when issue create fails',
	},
	createErrorFlagTitleIssueTerminologyRefreshM4: {
		id: 'issue-create.modal.create-form.create-error-flag-title-issue-terminology-refresh-m4',
		defaultMessage: "We can't create {issueType}",
		description: 'Title for error flag when issue create fails',
	},
	createErrorFlagDescriptionIssueTermRefresh: {
		id: 'issue-create.modal.create-form.create-error-flag-description-issue-term-refresh',
		defaultMessage:
			"We're having some trouble creating the work item. Refresh the page and try again.",
		description: 'Description for error flag when issue create fails',
	},
	createErrorFlagDescriptionIssueTerminologyRefreshM4: {
		id: 'issue-create.modal.create-form.create-error-flag-description-issue-terminology-refresh-m4',
		defaultMessage: 'Refresh the page and try again.',
		description: 'Description for error flag when issue create fails',
	},
	timeoutForgeInlineFieldTitleIssueTermRefresh: {
		id: 'issue-create.modal.create-form.timeout-forge-inline-field-title-issue-term-refresh',
		defaultMessage: 'Work item created with exceptions',
		description: 'Title for warning flag shown when issue was created with exceptions.',
	},
	timeoutForgeInlineFieldTitleIssueTerminologyRefreshM4: {
		id: 'issue-create.modal.create-form.timeout-forge-inline-field-title-issue-terminology-refresh-m4',
		defaultMessage: 'Created {issueType} with exceptions',
		description: 'Title for warning flag shown when issue was created with exceptions.',
	},
	timeoutForgeInlineFieldDescriptionIssueTermRefresh: {
		id: 'issue-create.modal.create-form.timeout-forge-inline-field-description-issue-term-refresh',
		defaultMessage:
			"We created your work item but couldn't save the value of the <bold>{fields}</bold> field. If this happens again, notify your admin",
		description:
			'Description for warning flag shown when issue was created but some of the fields do not have anticipated value.',
	},
	timeoutForgeInlineFieldDescriptionIssueTerminologyRefreshM4: {
		id: 'issue-create.modal.create-form.timeout-forge-inline-field-description-issue-terminology-refresh-m4',
		defaultMessage:
			"We created your {issueType} but couldn't save the value of the <bold>{fields}</bold> field. If this happens again, notify your admin",
		description:
			'Description for warning flag shown when issue was created but some of the fields do not have anticipated value.',
	},
	singleRequiredCustomFieldIssueCreationBlockIssueTermRefresh: {
		id: 'issue-create.modal.create-form.single-required-custom-field-issue-creation-block-issue-term-refresh',
		defaultMessage:
			'You can’t create this work item because the {fieldName} field is required but hidden. Contact your admin to fix this.',
		description:
			'Description for warning flag shown when issue creation is blocked by single required custom field hidden by display conditions',
	},
	singleRequiredCustomFieldIssueCreationBlockIssueTerminologyRefreshM4: {
		id: 'issue-create.modal.create-form.single-required-custom-field-issue-creation-block-issue-terminology-refresh-m4',
		defaultMessage:
			'You can’t create this {issueType} because the {fieldName} field is required but hidden. Contact your admin to fix this.',
		description:
			'Description for warning flag shown when issue creation is blocked by single required custom field hidden by display conditions',
	},
	multipleRequiredCustomFieldsIssueCreationBlockIssueTermRefresh: {
		id: 'issue-create.modal.create-form.multiple-required-custom-fields-issue-creation-block-issue-term-refresh',
		defaultMessage:
			'You can’t create this work item because the required fields are hidden: {fieldsName}. Contact your admin to fix this.',
		description:
			'Description for warning flag shown when issue creation is blocked by multiple required custom fields hidden by display conditions',
	},
	multipleRequiredCustomFieldsIssueCreationBlockIssueTerminologyRefreshM4: {
		id: 'issue-create.modal.create-form.multiple-required-custom-fields-issue-creation-block-issue-terminology-refresh-m4',
		defaultMessage:
			'You can’t create this {issueType} because the required fields are hidden: {fieldsName}. Contact your admin to fix this.',
		description:
			'Description for warning flag shown when issue creation is blocked by multiple required custom fields hidden by display conditions',
	},
	createSuccessFlagDescriptionIssueTermRefresh: {
		id: 'issue-create.modal.create-form.create-success-flag-description-issue-term-refresh',
		defaultMessage: 'Work item "{issueKey}" has been successfully created.',
		description: 'Description for success flag when issue is created',
	},
});
